import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { motion } from 'motion/react';

import { Container, Box } from '@components/grid';
import { cmsImagesPropTypes, buttonPropTypes } from '../../prop-types';
import { imageTransform, buttonTransform } from '../../content/transforms';
import { matrixBlockQuery, menuCarouselItemsQuery, buttonQuery } from '../../content/query-snippets';
import { CategoryGrid } from '../category-grid';
import { LottieAnimator } from '../lottie-animator';
import whosHungry from '../lottie-animator/lotties/whos-hungry.json';

const MenuGridBlock = ({ items, hasAnimatedHeading, isHome, button }) => {
  const [shouldPlayAnimation, setShouldPlayAnimation] = useState(false);

  const currentButton = button.filter(b => b.link);

  const transformedButton = buttonTransform(currentButton);

  const blockItems = items
    .map(({ heading, image, ...rest }) => ({
      title: heading,
      image: imageTransform(image),
      ...rest,
    }))
    .filter(item => item.title && item.image);

  const hasAnimation = hasAnimatedHeading || isHome;

  return (
    <Container
      display="flex"
      flexDirection="column"
      mb={{ xs: '64px', lg: '120px' }}
      mt={{ xs: hasAnimation ? '73px' : '64px', lg: hasAnimation ? '106px' : '120px' }}
      alignItems="center"
      variant="featuredContent"
    >
      {hasAnimation && (
        <>
          <Box mb={{ xs: '104px', lg: '120px' }}>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 1 }}
              onViewportEnter={() => setShouldPlayAnimation(true)}
            >
              <LottieAnimator animationDataFile={whosHungry} shouldPlay={shouldPlayAnimation} />
            </motion.div>
          </Box>
        </>
      )}

      <CategoryGrid categories={blockItems} showMoreText={transformedButton?.text} buttonProps={transformedButton} />
    </Container>
  );
};

MenuGridBlock.query = `
  ... on contentMatrix_menuCarouselBlock_BlockType {
    ${matrixBlockQuery}
    ${menuCarouselItemsQuery}
    ${buttonQuery}
  }
`;

MenuGridBlock.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      menuIcon: PropTypes.string.isRequired,
      image: cmsImagesPropTypes,
    })
  ).isRequired,
  hasAnimatedHeading: PropTypes.bool,
  isHome: PropTypes.bool,
  button: PropTypes.oneOfType([PropTypes.arrayOf(buttonPropTypes), buttonPropTypes]),
};

MenuGridBlock.defaultProps = {
  hasAnimatedHeading: false,
  isHome: false,
  button: null,
};

export { MenuGridBlock };
